import React from "react";
import { useQuoteAccessories } from "../Store/entities/accessories/hooks";
import { useQuoteById, useQuoteTypeNameByQuoteId } from "../Store/entities/quotes/hooks";
import { useCurrentMultiplier } from "../Store/entities/multipliers/hooks";
import AccessoryAction from "./NewOptionFields/AccessoryActions";
import Table from "../Parts/Table";
import { useIsPsAdmin } from "../hooks";
import { useAssembliesByQuoteId } from "../Store/entities/assemblies/hooks";
import Money from "../Parts/Money";

type AccessoryTableProps = {
	quoteId: number;
};

const AccessoryTable = ({ quoteId }: AccessoryTableProps) => {
	const quoteAccessories = useQuoteAccessories(quoteId);

	const currentQuoteType = useQuoteTypeNameByQuoteId(quoteId);

	const multiplier = useCurrentMultiplier(quoteId);
	const multiplierValue = multiplier.multiplier ?? 1;
	const currencyMultiplier = multiplier.currency_multiplier ?? 1;

	const quote = useQuoteById(quoteId);

	const isEditable = quote?.editable ?? false;

	const isPsAdmin = useIsPsAdmin();

	const assemblies = useAssembliesByQuoteId(quoteId);

	const shippingColumnName = assemblies?.length > 0
		? "Shipping" : ((quote.ship_order ?? true)
			? "Shipping and Processing" : "Processing");

	return (quoteAccessories?.length === 0)
		? null
		: (
			<div
				className="quote-table"
				style={{
					overflowX: 'auto', overflowY: 'hidden', marginBottom: '0.25em'
				}}
			>
				<Table
					className="accessory-table"
					quoteType={currentQuoteType}
					noTBody
					style={{ width: '100%', zIndex: '20' }}
				>

					<tbody style={{ zIndex: 900 }}>

						<tr className="bold-row">
							<th className={currentQuoteType} colSpan={13}>
								<div className={`table-header ${currentQuoteType}`}>Accessories</div>
							</th>
						</tr>
						<tr>
							<th colSpan={4}>
								Name
							</th>
							<th colSpan={2}>
								Part Number
							</th>
							<th colSpan={2}>
								Price (
								{multiplier.currency}
								)
							</th>
							<th colSpan={2}>
								Total Price (
								{multiplier.currency}
								)
							</th>
							{
								isPsAdmin && (
									<th colSpan={2}>
										{shippingColumnName}
									</th>
								)
							}
							{isEditable && <th colSpan={2}>Actions</th>}
						</tr>
						{quoteAccessories.map((accessory) => (
							<tr key={accessory.line_number}>
								<td colSpan={4}>
									{accessory.name}
									{' '}
									x
									{accessory.quantity}
								</td>
								<td colSpan={2}>
									{accessory.part_number}
								</td>
								<td colSpan={2}>
									<Money
										value={(accessory.msrp / accessory.quantity) * currencyMultiplier}
									/>
									{/* ${accessory.msrp / accessory.quantity} */}
								</td>
								<td colSpan={2}>
									<Money
										value={accessory.msrp * multiplierValue * currencyMultiplier}
									/>
								</td>
								{isPsAdmin && (
									<td colSpan={2}>
										${accessory.shipping}
									</td>
								)}
								{isEditable && (
									<td colSpan={2}>
										<label htmlFor={`accessory-action-${accessory.line_number}`} hidden>
											Accessory Actions for
											{' '}
											{accessory.name}
										</label>
										<AccessoryAction
											quoteId={quoteId}
											lineNumber={accessory.line_number}
										/>
									</td>
								)}
							</tr>
						))}
					</tbody>
				</Table>
			</div>

		);
};

export default AccessoryTable;
